import React from 'react';
import PropTypes from 'prop-types';
import Alert from './Alert/Alert';
import { EmptyAlerts } from '../ReportStyles';

const Alerts = ({ alerts, isArchived }) => (
  <>
    {!!alerts && alerts.length > 0 ? (
      alerts
        .filter(({ Title: title }) => typeof title === 'string' && title.length > 0)
        .map(alert => <Alert key={alert.AlertId} alert={alert} isArchived={isArchived} />)
    ) : (
      <EmptyAlerts>
        <div>
          {isArchived
            ? 'There are currently no archived alerts.'
            : 'Great News! We did not find any of your information being used online.'}
        </div>
      </EmptyAlerts>
    )}
  </>
);

Alerts.defaultProps = {
  isArchived: false,
};

Alerts.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isArchived: PropTypes.bool,
};

export default Alerts;
